import { render, staticRenderFns } from "./PayWithWagestream.vue?vue&type=template&id=7134aa60&scoped=true&"
import script from "./PayWithWagestream.vue?vue&type=script&lang=js&"
export * from "./PayWithWagestream.vue?vue&type=script&lang=js&"
import style0 from "./PayWithWagestream.vue?vue&type=style&index=0&id=7134aa60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134aa60",
  null
  
)

export default component.exports